module.exports = __webpack_public_path__ + "public/languageIcon.svg?5919ece0";


//////////////////
// WEBPACK FOOTER
// ./public/languageIcon.svg
// module id = 1007
// module chunks = 8